/**
 * Request ID Generator
 *
 * Generates a UUID v4 for X-Request-Id correlation headers.
 * Uses the native Web Crypto API (no external dependencies).
 */

export function generateRequestId(): string {
  return crypto.randomUUID()
}
